import {Action, Module, Mutation, VuexModule} from "vuex-module-decorators";
import store from "../index";
import {Product, ProductApi} from "@/client/index";
import {BASE_PATH} from "@/main";

@Module({
    store,
    dynamic: true,
    name: 'service',
    namespaced: true
})
export default class ServiceStore extends VuexModule {

    products: Product[] = [];

    @Mutation
    public setServices(newServices: Product[]) {
        this.products = newServices;
    }

    @Action
    public async loadServices() {
        return new Promise((resolve, reject) => {
            new ProductApi({accessToken: this.context.rootState.oidcStore.access_token}, BASE_PATH).listProducts()
                .then(response => {
                    this.context.commit('setServices', response.data);
                    resolve(response)
                })
                .catch(error => {
                    reject(error.response)
                })
        });
    }

}
